module.exports = __webpack_public_path__ + "img/5.b93a0682.jpg";